import { MultiPoint } from "ol/geom";
import { Circle, Fill, Stroke, Style, Icon } from 'ol/style.js';
import Point from 'ol/geom/Point';
import RegularShape from 'ol/style/RegularShape';
import colors from 'dxf/src/util/colors'

var white = [255, 255, 255, 1];
var blue = [0, 153, 255, 1];
var width = 2;

var default1s = new Style({
    stroke: new Stroke({
        color: white,
        width: width + 2
    })
});
var default2s = new Style({
    stroke: new Stroke({
        color: blue,
        width: width
    })
});
var default2 = new Style();

var defaultBlack = new Style({
    stroke: new Stroke({
        color: 'black',
        width: width - 1
    })
});

var defaultWhite = new Style({
    stroke: new Stroke({
        color: 'white',
        width: width - 1
    })
});


export default class FeatureStyle {
    static curstomVectorStyle(ft, res, dark, selecting) {
        var styles = []
        var colorNumber = ft.get('colorNumber')
        if (dark) { // set line to white
            colorNumber = 7;
        }
        if (!dark && (colorNumber == 7)) { // make white black
            colorNumber = 0;
        }

        var featureColor = colors[colorNumber];
        if (res < 0.07) {
            var geometry = ft.getGeometry();

            var distanceBetweenPoints = res * 200;
            var distanceAlongLine = 0;
            var totalLength = 0;

            geometry.forEachSegment((start, end) => {
                var dx = end[0] - start[0];
                var dy = end[1] - start[1];

                var segmentLength = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                totalLength += segmentLength;

                var rotation = Math.atan2(dy, dx);
                var points = [];


                while (totalLength > distanceAlongLine) {
                    var pointOnLine = [
                        start[0] + (end[0] - start[0]) * (distanceAlongLine + segmentLength - totalLength) / segmentLength,
                        start[1] + (end[1] - start[1]) * (distanceAlongLine + segmentLength - totalLength) / segmentLength
                    ];
                    points.push(pointOnLine);

                    distanceAlongLine += distanceBetweenPoints;
                }
                if (points.length > 0) {
                    styles.push(new Style({
                        geometry: new MultiPoint(points),
                        image: new Icon({
                            src: 'images/arrow-white.png',
                            anchor: [0.75, 0.5],
                            rotateWithView: true,
                            rotation: -rotation,
                            color: selecting ? blue : featureColor,
                            scale: 0.7
                        }),
                    }));
                }
            })
        }

        var lineStyle1 = selecting ? default1s : new Style({
            stroke: new Stroke({
                color: featureColor,
                width: width - 1
            })
        });
        var lineStyle2 = selecting ? default2s : default2;


        return [lineStyle1, lineStyle2, ...styles];
    }

    static defaultSelectedStyle() {
        return [default1s, default2s];
    }

    static curstomEnvironmentStyle(ft, res, dark, selecting) {
        var colorNumber = ft.get('colorNumber')

        if (dark && (colorNumber == 0 || colorNumber == 18)) { // make black and darkred(dxflib issue?) white
            colorNumber = 7;
        }
        if (!dark && (colorNumber == 7)) { // make white black
            colorNumber = 0;
        }

        var featureColor = colors[colorNumber];

        var lineStyle1 = selecting ? default1s : new Style({
            stroke: new Stroke({
                color: featureColor,
                width: width - 1
            })
        });
        var lineStyle2 = selecting ? default2s : default2;


        return [lineStyle1, lineStyle2];
    }

    static customSprayPointEnvironmentStyle(ft, res, dark, selecting) {
        return [new Style({ stroke: new Stroke({ color: 'black', width: width - 1 }) })]
    }

    static customLineStyle(ft, res, dark, selecting) {
        var featureColor = colors[ft.get('colorNumber')];
        var black;

        if (ft.get('colorNumber') == 7 && !dark) {
            featureColor = colors[0];
        } else if (dark && (ft.get('colorNumber') == 0 || ft.get('colorNumber') == 18)) {
            featureColor = colors[7];
        }

        black = new Style({
            stroke: new Stroke({
                color: featureColor,
                width: width - 1
            })
        });

        if (selecting) {
            // select style should be like motionplan
            var selectVertexStyle = new Style({
                image: new Circle({
                    fill: new Fill({
                        color: "#ffffff" // "#00008c"
                    }),
                    radius: 4,
                    stroke: new Stroke({
                        color: blue,
                        width: 1
                    })
                }),
                geometry: function (feature) {
                    var vertices = feature.get("vertices");
                    if (!vertices) {
                        return null;
                    }
                    var geom = new MultiPoint(vertices);
                    return geom;
                }
            })


            return [default1s, default2s, selectVertexStyle]
        }
        else {
            return [black]
        }
    }

    static customSelectedLayerLineStyle(ft, res, dark, selecting) {
        var green = new Style({
            stroke: new Stroke({
                color: '#50cc00',
                width: width
            })
        });
        return [green];
    }

    static customSprayPointsStyle(ft, res, dark, selecting) {
        // lineStyle1 and lineStyle2 make together the default line style
        var lineStyle1 = selecting ? default1s : (dark ? defaultWhite : defaultBlack)
        var lineStyle2 = selecting ? default2s : default2;


        if (selecting) {
            // select style should be like motionplan
            var selectVertexStyle = new Style({
                image: new Circle({
                    radius: 4,
                    fill: new Fill({
                        color: 'blue'
                    })
                }),
                geometry: function (feature) {
                    var geom = feature.get('stylegeom');
                    if (!geom) {
                        geom = new MultiPoint(feature.getGeometry().getCoordinates());
                        feature.set('stylegeom', geom);
                    }
                    return geom;
                }
            })
            return [default1s, default2s, selectVertexStyle]
        } else {
            return [
                // style for the polyline
                new Style({
                    stroke: new Stroke({
                        color: "#969696",
                        width: width - 1,
                    })
                }),
                // style for the vertices
                new Style({
                    image: new Circle({
                        radius: 4,
                        fill: new Fill({
                            color: 'blue'
                        })
                    }),
                    geometry: function (feature) {
                        var geom = feature.get('stylegeom');
                        if (!geom) {
                            geom = new MultiPoint(feature.getGeometry().getCoordinates());
                            feature.set('stylegeom', geom);
                        }
                        return geom;
                    }
                })
            ];
        }
    }



    static customProfilerStyle(ft, res, dark, selecting) {
        // Note: hide 1/3 of all features if we zoom out. This will increase perfocemance
        // Because the profiler map contains al lot of close lines you won't notice or need all the details on high zoom levels
        // TODO: we can hide all data on high zoom levels if we have a environment/outline available
        //if (res > 1 && Math.random() > 0.1)
        //    return null;
        if (ft.get('itemType') == 'HATCH') {
            var hatchStyle = new Style({
                fill: new Fill({
                    color: ft.get('color'),
                }),
            })

            return [hatchStyle]
        } else {
            var colorNumber = ft.get('colorNumber')
            if (dark) { // set line to white
                colorNumber = 7;
            }
            if (!dark && (colorNumber == 7)) { // make white black
                colorNumber = 0;
            }
            var featureColor = colors[colorNumber];

            var lineStyle1 = selecting ? default1s : new Style({
                stroke: new Stroke({
                    color: featureColor,
                    width: width
                })
            });
            var lineStyle2 = selecting ? default2s : default2;

            return [lineStyle1, lineStyle2];
        }
    }

    static customDiagnosticsStyle(ft, res, dark, selecting) {
        var white = [255, 255, 255, 1];
        var blue = [0, 153, 255, 1];
        var width = 3;
        var yellow = [245, 199, 26, 1];

        // lineStyle1 and lineStyle2 make together the default line style
        var lineStyle1 = null, lineStyle2 = null;

        switch (ft.get('type')) {
            case 'machine':
                // lineStyle1 = X point
                lineStyle1 = new Style({
                    image: new RegularShape({
                        fill: new Fill({
                            color: 'red'
                        }),
                        stroke: new Stroke({
                            color: 'black',
                            width: 1
                        }),
                        points: 4,
                        radius: 5,
                        angle: Math.PI / 4,
                        displacement: [0, 10],
                        rotation: (Math.PI * 0.5) - ft.get('heading') //0.250486 - (0.5 * Math.PI)
                    }),
                });
                lineStyle2 = new Style({
                    image: new RegularShape({
                        fill: new Fill({
                            color: 'red'
                        }),
                        stroke: new Stroke({
                            color: 'black',
                            width: 1
                        }),
                        points: 4,
                        radius: 10,
                        angle: Math.PI / 4,
                        rotation: (Math.PI * 0.5) - ft.get('heading') //0.250486 - (0.5 * Math.PI)
                    }),
                });
                break;
            case 'machineLine':
                lineStyle1 = new Style({
                    stroke: new Stroke({
                        color: 'purple',
                        width: 4,
                    }),
                });
                lineStyle2 = new Style({
                    // stroke: new Stroke({
                    //     color: blue,
                    //     width: 2,
                    // }),
                });
                break;
            default:
                lineStyle1 = new Style();
                lineStyle2 = new Style();
                break;
        }
        return [lineStyle1, lineStyle2];
    }
}